import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { WorkshopJobcardBookingDetailsComponent } from '../workshop-jobcard-booking-details/workshop-jobcard-booking-details.component';
import { WorkshopJobcardCustomerDetailsComponent } from '../workshop-jobcard-customer-details/workshop-jobcard-customer-details.component';
import { WorkshopJobcardItemDetailsComponent } from '../workshop-jobcard-item-details/workshop-jobcard-item-details.component';
import { WorkshopJobcardQuoteSearchAreaComponent } from '../workshop-jobcard-quote-search-area/workshop-jobcard-quote-search-area.component';
import { WorkshopJobcardCustomQuestionsComponent } from '../workshop-jobcard-custom-questions/workshop-jobcard-custom-questions.component';
import { WorkshopJobcardChecklistsComponent } from '../workshop-jobcard-checklists/workshop-jobcard-checklists.component';
import { WorkshopJobcardCollecionsDeliveriesComponent } from '../workshop-jobcard-collecions-deliveries/workshop-jobcard-collecions-deliveries.component';
import moment from 'moment';
import { HelpersService } from 'src/app/services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { WorkshopJobcardCreateService } from '../workshop-jobcard-create.service';
import { ServiceTypeService } from 'src/app/services/service-type.service';
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from 'rxjs';

export interface AccordionSection {
  id: string;
  title: string;
  subtitle?: string;
  isOpen: boolean;
  hasHeader: boolean;
  isCompleted?: boolean;
  hasAddButton?: boolean;
  hasCompleteButton?: boolean;
  hasSettings?: boolean;
  required: boolean
}

@Component({
  selector: 'app-workshop-jobcard-accordion',
  templateUrl: './workshop-jobcard-accordion.component.html',
  styleUrls: ['./workshop-jobcard-accordion.component.scss']
})
export class WorkshopJobcardAccordionComponent implements OnChanges {
  @Input() jobcard: any = {};
  @Input() serviceTypes: any[] = [];
  @Input() preServiceChecklist: any[] = [];
  @Input() productSKUServiceTypeCollection: any = [];
  @Input() technicians: any[] = [];
  @Input() systemUsers: any[] = [];
  @Input() thirdParties: any[] = [];
  @Input() linkedTags: any[] = [];
  @Input() collectionsConfigured: boolean = false;
  @Input() groupBookings: boolean = false; // New input for group bookings
  @Input() jobCards: any[] = []; // New input for job cards
  @Input() isPhoneView: boolean = false;
  @Output() jobcardChange = new EventEmitter<any>();
  @Output() linkedTagsOutput = new EventEmitter<any>();

  @ViewChild(WorkshopJobcardBookingDetailsComponent) bookingDetailsComponent: WorkshopJobcardBookingDetailsComponent;
  @ViewChild(WorkshopJobcardCustomerDetailsComponent) customerDetailsComponent: WorkshopJobcardCustomerDetailsComponent;
  @ViewChild(WorkshopJobcardItemDetailsComponent) itemDetailsComponent: WorkshopJobcardItemDetailsComponent;
  @ViewChild(WorkshopJobcardQuoteSearchAreaComponent) servicesProductsComponent: WorkshopJobcardQuoteSearchAreaComponent;
  @ViewChild(WorkshopJobcardCustomQuestionsComponent) customQuestionsComponent: WorkshopJobcardCustomQuestionsComponent;
  @ViewChild(WorkshopJobcardChecklistsComponent) checklistsComponent: WorkshopJobcardChecklistsComponent;
  @ViewChild(WorkshopJobcardCollecionsDeliveriesComponent) collectionsDeliveriesComponent: WorkshopJobcardCollecionsDeliveriesComponent;


  public customQuestions: any[] = [];
  public serviceTypeIDs: any[] = [];

  private checkCustomQuestionsSubject = new Subject<number[]>();
  private destroy$ = new Subject<void>();

  constructor(
    private helpersService: HelpersService,
    private modalService: NgbModal,
    private translate: TranslateService,
    private jobcardCreateService: WorkshopJobcardCreateService,
    private serviceTypeService: ServiceTypeService
  ) {
    this.checkCustomQuestionsSubject.pipe(
      debounceTime(300), // Wait 300ms after the last emission
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev.sort()) === JSON.stringify(curr.sort())
      ), // Only proceed if the service type IDs actually changed
      takeUntil(this.destroy$) // Unsubscribe when component is destroyed
    ).subscribe(serviceTypeIDs => {
      this.performCustomQuestionsCheck(serviceTypeIDs);
    });
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit() {
    this.initializeSections();
  }

  ngAfterViewInit() {
    //this.initializeSections();

    setTimeout(() => {

      if (this.customerDetailsComponent && !this.jobcardCreateService.isCustomerSectionCompleted(this.jobcard)) {
        this.customerDetailsComponent.searchCustomer();
      }
    }, 0);

  }

  reset() {
    this.sections.forEach(section => {
      section.isOpen = false,
        section.isCompleted = false
    });
  }


  ngOnChanges(changes: SimpleChanges): void {
    // Update validation when jobcard changes
    if (this.sections.length > 0) {
      setTimeout(() => {
        this.updateSectionValidation();
        this.addChecklistSection();
        this.checkForCustomQuestions();
      }, 0);
    }
  }

  onJobCardChange(event: any): void {
    this.jobcardChange.emit(event);
    this.updateSectionValidation();
  }

  onPreServiceChecklistChange(event: any): void {
    this.updateSectionValidation();
  }

  sections: AccordionSection[] = [];

  private initializeSections() {
    this.sections = [
      {
        id: 'customer-details',
        title: this.translate.instant('bikeshop.workshop.jobcard.customer_details'),
        isOpen: this.jobcard?.customer?.Locked ? false : true,
        hasAddButton: true,
        isCompleted: false,
        required: true,
        hasHeader: true
      },
      {
        id: 'item-details',
        title: this.translate.instant('bikeshop.workshop.jobcard.item_details'),
        isOpen: false,
        hasAddButton: true,
        isCompleted: false,
        required: true,
        hasHeader: true
      },
      {
        id: 'services-products',
        title: this.translate.instant('bikeshop.workshop.jobcard.services_and_products'),
        isOpen: this.jobcard?.customer?.Locked && this.jobcard?.selectedItem?.locked ? true : false,
        hasSettings: true,
        isCompleted: this.jobcardCreateService.isProductsAndServicesSectionCompleted(this.jobcard) || false,
        required: true,
        hasHeader: true
      },
      {
        id: 'booking-details',
        title: this.translate.instant('bikeshop.workshop.jobcard.booking_details'),
        isOpen: false,
        isCompleted: this.jobcardCreateService.isBookingSectionCompleted(this.jobcard) || false,
        required: true,
        hasHeader: true
      }, {
        id: 'extras',
        title: this.translate.instant('bikeshop.workshop.jobcard.extras'),
        isOpen: true,
        isCompleted: this.jobcardCreateService.isExtrasCompleted(this.jobcard) || false,
        required: false,
        hasHeader: true
      }
    ];

    if (this.isPhoneView) {
      this.sections.splice(2, 1); // Remove Services and Products section for phone view
      this.sections.splice(2, 0, {
        id: 'quote',
        title: '',
        isOpen: true,
        hasSettings: false,
        required: false,
        hasHeader: false
      });
    }

    if (this.collectionsConfigured) {
      //Q: how cain I insert a new section at a specific index?
      this.sections.splice(3, 0, {
        id: 'collections-deliveries',
        title: this.translate.instant('bikeshop.workshop.jobcard.collections_deliveries'),
        isOpen: false,
        hasAddButton: true,
        isCompleted: this.jobcardCreateService.isCollectionsComplete(this.jobcard, this.collectionsConfigured) || false,
        required: false,
        hasHeader: true
      });
    }
  }

  toggleSection(sectionId: string, event?: Event): void {
    if (event) {
      event.stopPropagation();
    }

    const section = this.sections.find(s => s.id === sectionId);
    if (section) {
      section.isOpen = !section.isOpen;
    }
  }

  onAddClick(sectionId: string, event: Event): void {
    if (event) {
      event.stopPropagation();
    }

    switch (sectionId) {
      case 'customer-details':
        if (this.customerDetailsComponent) {
          this.customerDetailsComponent.searchCustomer();
        } else {
          const customerSection = this.sections.find(s => s.id === 'customer-details');
          if (customerSection) {
            customerSection.isOpen = true;
          }
          setTimeout(() => {
            this.customerDetailsComponent.searchCustomer();
          }, 0);
        }
        break;
      case 'item-details':
        if (this.itemDetailsComponent) {
          this.itemDetailsComponent.showCustomerItems();
        } else {
          const itemSection = this.sections.find(s => s.id === 'item-details');
          if (itemSection) {
            itemSection.isOpen = true;
          }
          setTimeout(() => {
            this.itemDetailsComponent.showCustomerItems();
          }, 0);
        }
        break;
      case 'custom-questions':
        const customQuestionSection = this.sections.find(s => s.id === 'custom-questions');
        if (this.customQuestionsComponent) {
          this.customQuestionsComponent.showCustomQuestonDetails();
        } else {
          if (customQuestionSection) {
            customQuestionSection.isOpen = true;
          }
          setTimeout(() => {
            this.customQuestionsComponent.showCustomQuestonDetails();
          }, 0);
        }
        customQuestionSection.hasCompleteButton = false;
        break;
      case 'collections-deliveries':
        const collectionsSection = this.sections.find(s => s.id === 'collections-deliveries');
        if (this.collectionsDeliveriesComponent) {
          this.collectionsDeliveriesComponent.showCollectionDeliveryDetails();
        } else {
          if (collectionsSection) {
            collectionsSection.isOpen = true;
          }
          setTimeout(() => {
            this.collectionsDeliveriesComponent.showCollectionDeliveryDetails();
          }, 0);
        }
        break;
      case 'checklists':
        const checklistSection = this.sections.find(s => s.id === 'checklists');
        if (this.checklistsComponent) {
          this.checklistsComponent.openPreChecklist();
        } else {
          if (checklistSection) {
            checklistSection.isOpen = true;
          }
          setTimeout(() => {
            this.checklistsComponent.openPreChecklist();
          }, 0);
        }
        checklistSection.hasCompleteButton = false;
        break;
      default:
        console.warn(`No action defined for section: ${sectionId}`);
    }

  }

  onSettingsClick(sectionId: string, event: Event): void {
    event.stopPropagation();
  }

  getSectionById(sectionId: string): AccordionSection | undefined {
    return this.sections.find(s => s.id === sectionId);
  }


  private updateSectionValidation() {
    const customerSection = this.sections.find(s => s.id === 'customer-details');
    if (customerSection) {
      customerSection.hasAddButton = !this.jobcardCreateService.isCustomerSectionCompleted(this.jobcard);
      customerSection.isCompleted = this.jobcardCreateService.isCustomerSectionCompleted(this.jobcard);
      customerSection.subtitle = customerSection.isCompleted ? this.jobcard.customer.Name + ' ' + this.jobcard.customer.Surname : null;
    }
    const itemSection = this.sections.find(s => s.id === 'item-details');
    if (itemSection) {
      itemSection.hasAddButton = !this.jobcardCreateService.isItemSectionCompleted(this.jobcard);
      itemSection.isCompleted = this.jobcardCreateService.isItemSectionCompleted(this.jobcard);
      itemSection.subtitle = itemSection.isCompleted ? this.jobcard.selectedItem.manufacturer + " " + this.jobcard.selectedItem.model : null;
    }

    const bookingSection = this.sections.find(s => s.id === 'booking-details');
    if (bookingSection) {
      bookingSection.isCompleted = this.jobcardCreateService.isBookingSectionCompleted(this.jobcard);
      bookingSection.subtitle = this.jobcard.scheduleDate ? moment(this.jobcard.scheduleDate).format("ddd, D MMM yy, h:mma") : null;
    }

    const servicesAndProductsSection = this.sections.find(s => s.id === 'services-products');
    if (servicesAndProductsSection) {
      servicesAndProductsSection.isCompleted = this.jobcardCreateService.isProductsAndServicesSectionCompleted(this.jobcard);
    }

    const checklistsSection = this.sections.find(s => s.id === 'checklists');
    if (checklistsSection) {
      checklistsSection.isCompleted = this.jobcardCreateService.isPreServiceChecklistCompleted(this.preServiceChecklist);
    }

    const customQuestionSection = this.sections.find(s => s.id === 'custom-questions');
    if (customQuestionSection) {
      customQuestionSection.isCompleted = this.jobcardCreateService.isCustomQuestionsCompleted(this.jobcard);
    }

    const collectionsSection = this.sections.find(s => s.id === 'collections-deliveries');
    if (collectionsSection) {
      collectionsSection.isCompleted = this.jobcardCreateService.isCollectionsComplete(this.jobcard, this.collectionsConfigured);
      collectionsSection.hasAddButton = !collectionsSection.isCompleted;
      collectionsSection.subtitle = collectionsSection.isCompleted && this.jobcard.collectionsDeliveries?.collectionInfo?.scheduleDate ? moment(this.jobcard.collectionsDeliveries?.collectionInfo?.scheduleDate).format("ddd, D MMM yy") + ' / ' + this.jobcard.collectionsDeliveries?.collectionInfo?.timeSlot?.name : null;
    }

    const extraSection = this.sections.find(s => s.id === 'extras');
    if (extraSection) {
      extraSection.isCompleted = this.jobcardCreateService.isExtrasCompleted(this.jobcard);
    }

  }

  buttonEnabled(sectionId: string): boolean {
    const section = this.getSectionById(sectionId);
    if (!section) return false;

    switch (sectionId) {
      case 'item-details':
        return this.jobcard.customer && (this.jobcard.customer.ID || this.jobcard.customer.Email || this.jobcard.customer.PhoneNumber);
      case 'booking-details':
      case 'collections-deliveries':
      //return this.jobcard.selectedItem && !this.jobcard.itemIsHere;
      default:
        return true; // Default to true for other sections
    }
  }

  addChecklistSection() {
    var index = this.sections.findIndex(s => s.id === 'checklists');
    if (index === -1 && this.preServiceChecklist && this.preServiceChecklist.length > 0) {
      this.sections.push({
        id: 'checklists',
        title: this.translate.instant('bikeshop.workshop.jobcard.checklists'),
        isOpen: false,
        isCompleted: this.jobcardCreateService.isPreServiceChecklistCompleted(this.preServiceChecklist) || false,
        required: false,
        hasCompleteButton: true,
        hasHeader: true
      });
    }
  }

  checkForCustomQuestions() {
    const serviceTypeIDs = this.jobcard.selectedServiceTypes?.map((serviceType: any) => serviceType.serviceTypeID).sort((a, b) => {
      return a - b;
    }) || [];

    // Emit the service type IDs to the debounced subject
    this.checkCustomQuestionsSubject.next(serviceTypeIDs);
  }

  private performCustomQuestionsCheck(serviceTypeIDs: number[]) {
    console.log('Checking custom questions for service type IDs:', serviceTypeIDs);
    if (serviceTypeIDs.length === 0) {
      this.customQuestions = [];
      this.jobcard.customQuestions = this.customQuestions;
      this.serviceTypeIDs = [];
      var index = this.sections.findIndex(s => s.id === 'custom-questions');
      if (index > -1) {
        this.sections.splice(index, 1);
      }
      return;
    }

    // Only make API call if service type IDs have actually changed
    if (JSON.stringify(serviceTypeIDs) !== JSON.stringify(this.serviceTypeIDs)) {
      this.serviceTypeIDs = serviceTypeIDs;
      this.serviceTypeService.getServiceTypesCustomQuestions(this.helpersService.getPartnerId(), serviceTypeIDs).subscribe((result) => {
        this.customQuestions = result;
        this.jobcard.customQuestions = this.customQuestions;
        var index = this.sections.findIndex(s => s.id === 'custom-questions');
        if (index === -1 && this.customQuestions && this.customQuestions.length > 0) {
          var hasMandatoryCustomQuestions = this.customQuestions.some(q => q.customQuestions.some(cq => cq.mandatory));
          this.sections.push({
            id: 'custom-questions',
            title: this.translate.instant('bikeshop.workshop.jobcard.custom_questions'),
            isOpen: false,
            isCompleted: false,
            hasCompleteButton: true,
            required: hasMandatoryCustomQuestions,
            hasHeader: true
          });
        } else if (index > -1 && (this.customQuestions === null || this.customQuestions.length === 0)) {
          this.sections.splice(index, 1);
        }
      });
    }
  }


  closeSection(sectionId: string): void {
    const section = this.sections.find(s => s.id === sectionId);
    if (section) {
      section.isOpen = false;
    }
  }

  openSection(sectionId: string): void {
    const section = this.sections.find(s => s.id === sectionId);
    if (section) {
      section.isOpen = true;

      // Scroll to the section after opening
      setTimeout(() => {
        const element = document.getElementById(`section-${sectionId}`);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
          });
        }
      }, 100); // Small delay to ensure DOM is updated
    }
  }

  tagToggled(event) {
    console.log('Tag toggled:', event);
    this.linkedTags = event;
    this.linkedTagsOutput.emit(this.linkedTags);
  }

}
